export const parseInitialValues = entrance => entrance && entrance.attributes.type === 'lock' && entrance.attributes.config && entrance.attributes.config.provider === 'inlet' ? {
  entranceInletLockId: entrance.attributes.config.inletLockId,
  entranceInletOperation: entrance.attributes.config.inletOperation,
} : {};

export const formValues = [
  'entranceInletLockId',
  'entranceInletOperation',
];
